import { Node } from 'tiptap'
import { setBlockType, textblockTypeInputRule, toggleBlockType } from 'tiptap-commands'

export default class Input extends Node {

    get name() {
        return 'input'
    }

    get defaultOptions() {
        return {
        }
    }

    get schema() {
        return {
            attrs: {
                name: {
                    default: '',
                },
                label: {
                    default: '',
                },
                description: {
                    default: '',
                },
                rules: {
                    default: null,
                },
                input_type: {
                    default: 'text',
                },
            },
            group: 'block',
            defining: true,
            draggable: false,
            parseDOM: [{
                tag: 'tiptap-2milion-input',
                getAttrs: dom => ({
                    name: dom.getAttribute('name'),
                    label: dom.getAttribute('label'),
                    description: dom.getAttribute('description'),
                    rules: dom.getAttribute('rules'),
                    input_type: dom.getAttribute('input_type'),
                }),
            }],
            toDOM: node => ['tiptap-2milion-input', {
                name: node.attrs.name,
                label: node.attrs.label,
                description: node.attrs.description,
                rules: node.attrs.rules,
                input_type: node.attrs.input_type,
            }],
        }
    }

    commands({ type }) {
        return attrs => (state, dispatch) => {
            const { selection } = state;
            const position = selection.$cursor
                ? selection.$cursor.pos
                : selection.$to.pos;
            const node = type.create(attrs);
            const transaction = state.tr.insert(position, node);
            dispatch(transaction);
        };
    }

    get view() {
        return {
            props: ['node', 'updateAttrs', 'view'],
            computed: {
                name: {
                    get() {
                        return this.node.attrs.name
                    },
                    set(name) {
                        this.updateAttrs({
                            name,
                        })
                    },
                },
                label: {
                    get() {
                        return this.node.attrs.label
                    },
                    set(label) {
                        this.updateAttrs({
                            label,
                        })
                    },
                },
                description: {
                    get() {
                        return this.node.attrs.description
                    },
                    set(description) {
                        this.updateAttrs({
                            description,
                        })
                    },
                },
                rules: {
                    get() {
                        return typeof this.node.attrs.rules === 'string' ? this.node.attrs.rules.replace(/^\|+|\|+$/g, '').split('|') : this.node.attrs.rules
                    },
                    set(rules) {
                        this.updateAttrs({
                            rules: Array.isArray(rules) ? rules.join('|') : rules,
                        })
                    },
                },
                rules_text: {
                    get() {
                        return Array.isArray(this.node.attrs.rules) ? this.node.attrs.rules.join('|') : this.node.attrs.rules
                    },
                    set(rules_text) {
                        this.updateAttrs({
                            rules: rules_text
                        })
                    },
                },
                input_type: {
                    get() {
                        return this.node.attrs.input_type
                    },
                    set(input_type) {
                        this.updateAttrs({
                            input_type,
                        })
                    },
                },
            },
            methods: {
                hasRule(rule) {
                    if (!Array.isArray(this.rules)) {
                        return false
                    }
                    return this.rules.indexOf(rule) >= 0
                },
            },
            template: `
<div :class="{ 'p-3 mb-4 bg-light': view.editable, }">

<p class="mb-0" v-if="label"><strong>{{ label }}</strong></p><p class="mb-0" v-if="description">{{ description }}</p><b-form-input :name="name" :type="input_type" @cut.stop @copy.stop @paste.stop />

    <b-form-group
        label-cols-sm="2"
        label="設定"
        label-size="sm"
        @submit.stop.prevent
        v-if="view.editable"
        >
        <b-row>
            <b-col>
                <small>フィールド</small>
                <b-form-input
                    v-model="name"
                    size="sm"
                    type="text"
                    @cut.stop
                    @copy.stop
                    @paste.stop
                    />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <small>ラベル</small>
                <b-form-input
                    v-model="label"
                    size="sm"
                    type="text"
                    @cut.stop
                    @copy.stop
                    @paste.stop
                    />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <small>説明</small>
                <b-form-input
                    v-model="description"
                    size="sm"
                    type="text"
                    @cut.stop
                    @copy.stop
                    @paste.stop
                    />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <small>入力規則</small>
                <b-form-checkbox-group
                    v-model="rules"
                    size="sm"
                    >
                    <b-form-checkbox value="required">必須</b-form-checkbox>
                </b-form-checkbox-group>
                <b-form-input
                    v-model="rules_text"
                    size="sm"
                    type="text"
                    style="margin-top: -1.5em;"
                    @cut.stop
                    @copy.stop
                    @paste.stop
                    />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <small>タイプ</small>
                <b-form-select
                    v-model="input_type"
                    size="sm"
                    >
                    <b-form-select-option value="text">テキスト</b-form-select-option>
                    <b-form-select-option value="number">数値</b-form-select-option>
                    <b-form-select-option value="email">メールアドレス</b-form-select-option>
                    <b-form-select-option value="tel">電話番号</b-form-select-option>
                </b-form-select>
            </b-col>
        </b-row>
    </b-form-group>
</div>
                `,
        }
    }

}
